import {
    ColumnType,
    DetailGridIgnore,
    DisplayName,
    TableColumn,
    TableIgnore,
    yascBic,
    yascHint,
    yascIban,
    yascMaxLength,
    yascMinLength,
    yascPlaceholder,
    yascRequired,
} from '@yasc/yasc-material-components';

export class BankAccountRes {
    @TableIgnore(true)
    @DetailGridIgnore()
    public guid!: string;

    @DisplayName('formular_bankAccount_accountOwner_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public accountOwner!: string;

    @DisplayName('formular_bankAccount_bankName_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public bankName!: string;

    @DisplayName('formular_bankAccount_iban_label')
    @yascRequired()
    @yascIban()
    @yascMinLength(15)
    @yascMaxLength(34)
    @yascPlaceholder('DE89 3704 0044 0532 0130 00')
    @yascHint('formular_bankAccount_iban_hint')
    public iban!: string;

    @DisplayName('formular_bankAccount_bic_label')
    @yascRequired()
    @yascBic()
    @yascMinLength(8)
    @yascMaxLength(11)
    @yascPlaceholder('COBADEFFXXX')
    @yascHint('formular_bankAccount_bic_hint')
    public bic!: string;

    @DisplayName('formular_bankAccount_default_label')
    @TableColumn(ColumnType.Switch)
    public default!: boolean;

    @DisplayName('formular_bankAccount_billingAccountOnly_label')
    @TableColumn(ColumnType.Switch)
    public billingAccountOnly!: boolean;

    @TableIgnore(true)
    @DetailGridIgnore()
    public finApiBankId?: number;

    constructor(account?: BankAccountRes) {
        if (account === undefined) return;

        this.accountOwner = account.accountOwner;
        this.bankName = account.bankName;
        this.iban = account.iban;
        this.bic = account.bic;
        this.guid = account.guid;
        this.default = account.default;
        this.billingAccountOnly = account.billingAccountOnly;
        this.finApiBankId = account.finApiBankId;
    }

    toString(): string {
        return `IBAN: ${this.iban}\nBic: ${this.bic}`;
    }
}

export class TaxOfficeDetailsRes {
    id?: number;
    @DisplayName('general_name')
    @yascMaxLength(100)
    name: string = '';
}

export class CourtOfficeDetailsRes {
    id?: number;
    @DisplayName('general_name')
    @yascMaxLength(100)
    name: string = '';
    @DisplayName('general_nr')
    @yascMaxLength(50)
    nr: string = ''
}
